import { CHAT_MESSAGE_STATUS } from '@/utils/constants';

import type { TMessage } from '@stores/chat-domain.types';
import type { TMessagesState, TMessagesAction } from '../conversation-messages.types';

export const messagesReducer = (
	state: TMessagesState,
	action: TMessagesAction,
): TMessagesState => {
	switch (action.type) {
		case 'APPEND_MY_MESSAGES':
			return {
				source: [...state.source, ...action.payload],
				newMessage: true,
			};
		case 'APPEND_OTHER_MESSAGES':
			return {
				source: [
					...state.source.map((msg: TMessage) => {
						msg.statusMessage = CHAT_MESSAGE_STATUS.read;
						return msg;
					}),
					...action.payload,
				],
				newMessage: true,
			};
		case 'UPDATE_STATUSES':
			return { source: action.payload, newMessage: null };
		case 'PREPEND_OLDER':
			return {
				source: [...action.payload, ...state.source],
				newMessage: false,
			};
		case 'RESET':
			return { source: action.payload, newMessage: false };
		default:
			return state;
	}
};
